/* eslint-disable tailwindcss/no-custom-classname */
import { useDispatch } from 'react-redux'
import {
  initialHeaderState,
  modalFadeIn,
  setOpen as setLoginOpen,
} from '@/stores'
import { Shop, SummaryDetail } from '@/types/summary'
import { CourseId, Reason } from '@/types/user'
import { Readable, SilverWithinLimit, ShopList, Free, Anonymous } from './'
import { SILVER_MAX_BOOK_COUNT } from '@/utils/constant'
import { SilverOverLimit } from './SilverOverLimit'

interface Props {
  shops: Shop[]
  summary: SummaryDetail
  reason?: Reason
  courseId?: number
  readThisMonth?: number
}
export const SubMenu: React.FC<Props> = ({
  shops,
  summary,
  reason = Reason.CAN_NOT_READABLE,
  courseId = CourseId.anonymous,
  readThisMonth = 0,
}) => {
  const dispatch = useDispatch()
  const handleClickLogin = (e) => {
    e.stopPropagation()
    dispatch(
      setLoginOpen({
        ...initialHeaderState.open,
        modalBackdrop: true,
        modalLoginForm: modalFadeIn,
      })
    )
  }

  /**
   * reasonとコースIDによってメニューを出し分け
   */
  const renderMenu = () => {
    if (courseId === CourseId.anonymous) {
      return <Anonymous onClick={handleClickLogin} />
    }
    if (reason !== Reason.READABLE) {
      if (courseId === CourseId.free) {
        return <Free />
      } else if (courseId === CourseId.silver) {
        if (readThisMonth >= SILVER_MAX_BOOK_COUNT) {
          return <SilverOverLimit />
        } else {
          return (
            <SilverWithinLimit
              summary={summary}
              readThisMonth={readThisMonth}
            />
          )
        }
      }
    } else {
      return <Readable summary={summary} />
    }
  }

  return (
    <div className="w-[278px] h-full text-[15px] align-top">
      {renderMenu()}
      <ShopList shops={shops} />
    </div>
  )
}
